class HeadlineCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.level = options?.level ? 2
        @.size = options?.size ? 2
        @.text = options?.text ? "Überschrift"

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement "h#{ @.level }"
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.classList.add "headline", "headline--#{ @.size }"
        @.$el.innerHTML = @.text
        return

window.CreateHeadline = (options) ->
    return new HeadlineCreate options